package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.BookSederItem
import com.eladfinish.bible.contest.data.SederData
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.sedarim_json
import com.eladfinish.bible.contest.seder_str_placeholder
import com.eladfinish.bible.contest.seder_str_placeholder_no_name
import com.eladfinish.bible.contest.utils.addGershaim
import dev.icerock.moko.resources.format

class ParseSedarimUseCase(
    assetReader: AssetReader,
) {

    private val sedarimMapping: String by lazy { assetReader.readFile(SharedRes.assets.sedarim_json) }

    private val sedarim: List<BookSederItem> by lazy { sedarimMapping.convertToDataClass<List<BookSederItem>>() }

    operator fun invoke(bookNumber: Int): List<SederData> {
        return sedarim[bookNumber.coerceAtMost(maximumValue = sedarim.lastIndex)].sections.map {
            val seder = it.seder.addGershaim()
            SederData(
                name = if (it.name.isBlank()) {
                    SharedRes.strings.seder_str_placeholder_no_name.format(seder)
                } else {
                    SharedRes.strings.seder_str_placeholder.format(seder, it.name)
                },
                start = it.start,
                end = it.end,
            )
        }
    }
}
